import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificationModel } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private httpClient: HttpClient) {}

  public getNotifications() : Observable<NotificationModel[]> {
    return this.httpClient.get<NotificationModel[]>(`${environment.apis.thirdParty}/notification`);
  }
}
